import React from 'react';
import Navigation from '../Shared/Navigation/Navigation';
import MentorBanner from './MentorBanner/MentorBanner';

const MentorForm = () => {
    return (
        <div>
            <Navigation></Navigation>
            <MentorBanner></MentorBanner>
        </div>
    );
};

export default MentorForm;